export const LK_LINK_TEXT = 'Личный кабинет';

export const LOGO_IMAGE_LINKS = {
  gray: 'https://static.uchi.ru/files/content-1-4/landings/common/images/header-uchiru-logo.svg',
  transparentBlack:
    'https://static.uchi.ru/files/content-1-4/landings/common/images/header-uchiru-logo-black.svg',
  transparentWhite:
    'https://static.uchi.ru/files/content-1-4/landings/common/images/header-uchiru-logo-white.svg',
};
